<template>
    <div>
        <h3>What does 'All Inclusive' mean?</h3>
        <p>Asda Tyres has invested heavily in improving and expanding our all inclusive tyre service. We have worked hard to ensure our fully fitted option is as straight forward &amp; convenient as it can be.</p>
        <p>Please note we do not include TPMS valve replacement in our prices, if you need your TPMS valves replacing this will incur further charges. It is recommended to have your valves serviced regularly to avoid sensors developing faults.</p>
        <div class="bg-light px-2 py-1 w-100 my-2">
            <h3 class="my-2 h4">What's included?</h3>
        </div>
        <ul>
            <li>Tyre fitting by an experienced fitter</li>
            <li>Wheel Balancing</li>
        </ul>
        <div class="bg-light px-2 py-1 w-100 my-2">
            <h3 class="my-2 h4">Step 1: Select your tyres</h3>
        </div>
        <p>Either, enter your vehicle registration number or your tyre size into one of our search tools and select the tyres you want from the list. All the tyres shown after you’ve entered your registration number or the size will be suitable for your vehicle.</p>
        <div class="bg-light px-2 py-1 w-100 my-2">
            <h3 class="my-2 h4">Step 2: Select a local fitting centre</h3>
        </div>
        <p>Once you've selected your tyres, you will need to enter your postcode and you will see the nearest fitting centre to your postcode. We work alongside hundreds of tyre fitting centres throughout the UK and the vast majority of the UK population will have a centre within a few miles of their specified postcode.</p>
        <p>Each fitting centre has been vetted and is fully insured to carry out work on our behalf. Once you have selected a local fitting centre, you can choose a date and time most convenient for you.</p>
        <div class="bg-light px-2 py-1 w-100 my-2">
            <h3 class="my-2 h4">Step 3: Turn up at your appointment</h3>
        </div>
        <p>Once you have placed your order all you need to do is turn up at your appointment and our team will fit your new tyres and ensure your wheels are balanced.</p>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>